@let small = containerSize();
<div
  #container
  class="chat-start-view"
  [class.chat-start-view--small]="small === 'small'">
  @if (!small && small !== null) {
    <div class="chat-start-view__header">
      <coin-chat-mascot></coin-chat-mascot>
    </div>
  }
  <div class="chat-start-view__content">
    @if (small && small !== null) {
      <div class="chat-start-view__small-header">
        <coin-chat-mascot></coin-chat-mascot>
        <ng-container *ngTemplateOutlet="headerTitle"></ng-container>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="headerTitle"></ng-container>
    }
    <ul class="chat-start-view__prompts">
      @for (prompt of selectedPrompts(); track $index) {
        <li class="chat-start-view__prompt">
          <coin-prompt-button (press)="promptSelected.emit(prompt)">{{ prompt }}</coin-prompt-button>
        </li>
      }
    </ul>
    @if (prompts().length > 3) {
      <div class="chat-start-view__footer">
        <coin-v2-button
          type="outline"
          icon="restart_alt"
          [text]="newPromptLabel() | translate"
          (click)="generateNewPrompts()" />
      </div>
    }
  </div>
</div>

<ng-template #headerTitle>
  <h4 class="chat-start-view__header-title">
    {{ 'chat-bot.window.greeting' | translate }} {{ userName() }}, {{ 'chat-bot.window.intro-question' | translate }}
  </h4>
</ng-template>
